var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header"},[_c('div',{staticClass:"left"},[_c('a',{staticClass:"d-flex",attrs:{"href":"https://www.kernsystems.com","target":"_blank"}},[_c('span',{staticClass:"icon"})]),_c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"first"},[_vm._v("Olli")]),_c('span',{staticClass:"second"},[_vm._v("by Kern Systems")])])])])
}]

export { render, staticRenderFns }